import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  wooSuccess: 'With this payment, you have saved approximately',
  wooSuccessAmount: '{{amount}} {{currency}}',
  wooReferral: "Don't forget to refer a company to earn",
  wooReferralAmount: '{{amount}} {{currency}}** per referral*',
  wooReferralButton: 'Refer',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const WOO_MOMENTS_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    wooSuccess: 'Con este pago, has ahorrado aproximadamente',
    wooSuccessAmount: '{{amount}} {{currency}}',
    wooReferral: 'No olvides referir a una empresa para ganar',
    wooReferralAmount: '{{amount}} {{currency}}** por cada referencia*',
    wooReferralButton: 'Referir',
  },
};

export default WOO_MOMENTS_LANGUAGE_LABELS;
